import qs from 'qs';

export const getPagingHref = (href, page, options = {}) => {
	if (!href) return undefined;
	const { noFirstPage = true } = options;

	const [url, search] = href.split('?');
	const query = search ? qs.parse(search) : {};

	const newQuery = {
		...query,
		page,
	};

	if (noFirstPage && +page === 1) {
		delete newQuery.page;
	}

	const newSearch = qs.stringify(newQuery, {
		arrayFormat: 'comma',
	});

	return `${url}${newSearch ? `?${newSearch}` : ''}`;
};
